import Vue from "vue";
import "./plugins/axios";
import BacoSearchEngine from "./BacoSearchEngine.vue";
import VueAutosuggest from "vue-autosuggest";

Vue.config.productionTip = false;
Vue.use(VueAutosuggest);
Vue.component("baco-search-engine", BacoSearchEngine);
new Vue({}).$mount("#app");
